/** The Snipe-IT status label name used for devices sent to the recycler. */
export const VERWERTER_STATUS = "Verwerter";
